import { extend } from "vee-validate";
import { email, required } from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/pt_BR.json";

let myRules = { email: email, required: required };


Object.keys(myRules).forEach(rule => {
    extend(rule, {...myRules[rule], message: messages[rule]});
});